import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * Component that handles the threshold progress bar functionality
 * @extends Component
 */
class ThresholdProgressBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Listen for cart updates
    document.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);

    // Initial update
    this.updateProgressBar();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate);
  }

  /**
   * Handles cart update events
   * @param {import('@theme/events').CartUpdateEvent} event
   */
  handleCartUpdate = (event) => {
    this.updateProgressBar();
  };

  /**
   * Updates the progress bar based on current cart total
   */
  updateProgressBar() {
    const progressBarTrigger = this.querySelector(".process-bar-trigger");

    if (!progressBarTrigger) {
      console.warn(
        "[ThresholdProgressBar] Progress bar trigger element not found"
      );
      return;
    }

    const progressElement = /** @type {HTMLElement} */ (progressBarTrigger);
    setTimeout(() => {
      const width = parseFloat(progressElement.dataset.width || "0");

      // Animate width transition
      progressElement.style.width = `${width}%`;

      // Update threshold state classes
      const isComplete = width >= 100;

      progressBarTrigger.classList.toggle("threshold-complete", isComplete);
    }, 200);
  }
}

if (!customElements.get("threshold-progress-bar")) {
  customElements.define("threshold-progress-bar", ThresholdProgressBar);
}
